<template>
  <router-link
    :to="{ path: `/admin/notes/${note.id}/update` }"
    class="px-3 py-2 block"
  >
    <span v-html="title"></span>
  </router-link>
</template>

<script>
export default {
  props: ["note"],
  computed: {
    title() {
      let title = "";
      // If a note has a date and no title, display the date
      if (this.note.date && !this.note.title) {
        title = this.note.date;
      } else if (this.note.title && !this.note.date) {
        title = this.note.title;
      } else if (this.note.title && this.note.date) {
        title = this.note.title + " (" + this.note.date + ")";
      }
      return title;
    }
  }
};
</script>
